export const formatBirthDate = (
  birthDate: string,
  locale: string = "en-US",
): string => {
  if (!birthDate) {
    return "";
  }

  try {
    const date = new Date(birthDate);
    return date.toLocaleDateString(locale, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } catch {
    return birthDate;
  }
};

export const parseUTCDate = (dateString: string): Date => {
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
};

export const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export interface BirthDateRange {
  birthDateFrom?: string;
  birthDateTo?: string;
}

export const calculateBirthDateRange = (
  ageFrom: number | null,
  ageTo: number | null,
  referenceDate: Date = new Date(),
): BirthDateRange => {
  const currentYear = referenceDate.getFullYear();
  const currentMonth = referenceDate.getMonth();
  const currentDay = referenceDate.getDate();

  let birthDateFrom: string | undefined;
  let birthDateTo: string | undefined;

  if (ageTo !== null) {
    const yearFrom = currentYear - ageTo;
    birthDateFrom = formatDate(new Date(yearFrom, currentMonth, currentDay));
  }

  if (ageFrom !== null) {
    const yearTo = currentYear - ageFrom;
    birthDateTo = formatDate(new Date(yearTo, currentMonth, currentDay));
  }

  return { birthDateFrom, birthDateTo };
};
